<template>
  <div class="colu colu-12">
    <!-- Google Auth 模式 -->
    <template v-if="googleAuthEnabled">
      <label class="colu-12 for-label" :for="inputId">
        {{ $t('Bao.google_auth_verification') }}
      </label>
      <input
        :id="inputId"
        :value="otpCode"
        class="for-input inpType"
        type="password"
        :placeholder="$t('Bao.google_auth_default_verification')"
        autocomplete="off"
        @input="$emit('update:otp-code', $event.target.value)"
      >
    </template>

    <!-- 一般提款密碼模式 -->
    <template v-else>
      <label class="colu-12 for-label" :for="inputId">
        {{ $t('Bao.withdrawal_password') }}
      </label>
      <input
        :id="inputId"
        :value="withdrawalPass"
        class="for-input inpType"
        type="password"
        :placeholder="$t('Bao.withdrawal_password_default')"
        autocomplete="off"
        @input="$emit('update:withdrawal-pass', $event.target.value)"
      >
    </template>
  </div>
</template>

<script>
export default {
  name: 'AuthInput',
  props: {
    googleAuthEnabled: {
      type: Number,
      default: 0
    },
    withdrawalPass: {
      type: String,
      default: ''
    },
    otpCode: {
      type: String,
      default: ''
    },
    /** 避免 MB/PC 同頁面 id 重複 */
    inputId: {
      type: String,
      default: 'auth-input'
    }
  }
}
</script>
